export enum ReviewedStatus {
    All = 0,
    NotReviewed = 1,
    Reviewed = 2
}